import { Shield } from 'lucide-react';

export default function TermsPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="terms-page">
      <div className="flex items-center gap-3 mb-8">
        <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Shield className="h-5 w-5 text-primary" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight" style={{ fontFamily: 'Outfit' }}>Termos de Uso</h1>
      </div>

      <div className="prose prose-sm max-w-none text-muted-foreground space-y-6">
        <p className="text-xs text-muted-foreground/70">Última atualização: Junho de 2026</p>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">1. Aceitação dos Termos</h2>
          <p>Ao acessar e utilizar a plataforma VENDA DE GARAGEM, você concorda com estes Termos de Uso. Se você não concordar com algum dos termos aqui dispostos, não utilize a plataforma.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">2. Descrição do Serviço</h2>
          <p>A VENDA DE GARAGEM é uma plataforma de marketplace online que conecta compradores e vendedores para a comercialização de produtos físicos, produtos digitais e serviços. A plataforma atua como intermediária, disponibilizando ferramentas para anúncio, comunicação e pagamento seguro entre as partes.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">3. Cadastro e Conta</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>Para utilizar os serviços da plataforma, é necessário criar uma conta com informações verídicas e atualizadas.</li>
            <li>Cada pessoa física ou jurídica pode possuir apenas uma conta ativa.</li>
            <li>O usuário é responsável por manter a confidencialidade de suas credenciais de acesso.</li>
            <li>A VENDA DE GARAGEM reserva-se o direito de suspender ou encerrar contas que violem estes Termos.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">4. Sistema de Créditos</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>A plataforma utiliza um sistema de créditos internos onde 1 (um) crédito equivale a R$ 1,00 (um real).</li>
            <li>Os créditos podem ser adquiridos através dos métodos de pagamento disponíveis (PIX, Boleto, Cartão de Crédito).</li>
            <li>Créditos não utilizados podem ser resgatados conforme as políticas de saque vigentes.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">5. Compra e Venda</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>Os vendedores são integralmente responsáveis pela veracidade das informações dos produtos anunciados, incluindo descrição, fotos, vídeos e preço.</li>
            <li>As transações são realizadas através do sistema de escrow (custódia) da plataforma, que retém o pagamento até a confirmação de recebimento pelo comprador.</li>
            <li>É proibido anunciar produtos ilegais, falsificados, roubados ou que violem direitos de terceiros.</li>
            <li>A VENDA DE GARAGEM não se responsabiliza pela qualidade, segurança ou legalidade dos produtos anunciados.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">6. Taxas e Comissões</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>A plataforma cobra uma taxa de negociação sobre cada venda concluída, conforme percentual vigente e exibido no momento da criação do anúncio.</li>
            <li>Uma taxa de escrow é aplicada para cobrir os custos de processamento e segurança da transação, cobrada de ambas as partes (comprador e vendedor).</li>
            <li>Serviços adicionais, como vídeo premium e destaque de anúncios, possuem custos específicos informados antes da contratação.</li>
            <li>As taxas podem ser alteradas mediante aviso prévio aos usuários.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">7. Comunicação entre Usuários</h2>
          <p>A plataforma disponibiliza um sistema de chat para comunicação entre compradores e vendedores. É proibido utilizar o chat para:</p>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>Enviar spam, publicidade não solicitada ou conteúdo ofensivo;</li>
            <li>Compartilhar dados pessoais sensíveis de terceiros;</li>
            <li>Negociar transações fora da plataforma com o intuito de burlar as taxas;</li>
            <li>Praticar qualquer forma de fraude, assédio ou atividade ilícita.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">8. Propriedade Intelectual</h2>
          <p>Todo o conteúdo da plataforma VENDA DE GARAGEM, incluindo marca, layout, código-fonte e elementos gráficos, é protegido por direitos autorais. É proibida a reprodução, distribuição ou uso sem autorização prévia.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">9. Limitação de Responsabilidade</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>A VENDA DE GARAGEM não é parte nas transações realizadas entre compradores e vendedores, atuando apenas como intermediária.</li>
            <li>A plataforma não garante a disponibilidade ininterrupta dos serviços e não se responsabiliza por perdas decorrentes de falhas técnicas.</li>
            <li>Eventuais disputas entre compradores e vendedores devem ser resolvidas primeiramente entre as partes, podendo a plataforma auxiliar na mediação.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">10. Modificações dos Termos</h2>
          <p>A VENDA DE GARAGEM reserva-se o direito de alterar estes Termos de Uso a qualquer momento. As alterações serão comunicadas através da plataforma e/ou por e-mail. O uso continuado da plataforma após a publicação das alterações implica na aceitação dos novos termos.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">11. Legislação Aplicável</h2>
          <p>Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil, em especial o Código de Defesa do Consumidor (Lei nº 8.078/1990), o Marco Civil da Internet (Lei nº 12.965/2014) e a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 — LGPD).</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">12. Contato</h2>
          <p>Em caso de dúvidas, reclamações ou solicitações, entre em contato conosco através do e-mail: <a href="mailto:vendagsac@gmail.com" className="text-primary hover:underline font-medium">vendagsac@gmail.com</a></p>
        </section>
      </div>
    </div>
  );
}
